module.exports = __webpack_public_path__ + "static/glasses-7069032ecea0977691ecc70db52a6c4a.svg";